import { useAtomValue } from 'jotai'
import React from 'react'

import { type ColumnInfo, getDiffKey } from '~/utils'

import { columnsDiffsAtom, countColumnKeysAtom } from '../atoms'
import { type ColumnKey } from '../utils'

const widthMap: Record<ColumnKey, string> = {
  category: '180px',
  subcategory: 'max-content',
}

export const useTableColumns = (): ColumnInfo<ColumnKey>[] => {
  const countColumnKeys = useAtomValue(countColumnKeysAtom)
  const columnsDiffs = useAtomValue(columnsDiffsAtom)

  return React.useMemo(() => {
    const columnKeys: ColumnKey[] = [
      'category',
      'subcategory',
      ...countColumnKeys,
      ...columnsDiffs.map(getDiffKey),
    ]

    return columnKeys.map((key) => ({ key, width: widthMap[key] ?? '160px' }))
  }, [countColumnKeys, columnsDiffs])
}
